import React from 'react';
import { PatchNoteVersionSection } from './PatchNoteVersionSection/PatchNoteVersionSection.tsx';
import { PatchNotesAnnouncementSection } from './PatchNotesAnnouncementSection/PatchNotesAnnouncementSection.tsx';
import styles from './PatchNotesContent.module.scss';
export function PatchNotesContent({ patchNotes, announcements, onExternalClick, onProfileClick }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement(PatchNotesAnnouncementSection, {
        announcements: announcements
    }), patchNotes.map((patchNote, index)=>/*#__PURE__*/ React.createElement(PatchNoteVersionSection, {
            key: index,
            patchNote: patchNote,
            onExternalClick: onExternalClick,
            onProfileClick: onProfileClick
        })));
}
